import React from 'react';
import PropTypes from 'prop-types';
import { isSupportedFeature, constants as features } from '@saucelabs/sl-component-supported-feature';

import JobsUserContainer from './JobsUserContainer';
import FlatBuildsContainer from './FlatBuildsContainer';
import {
  constants as filterConstants,
} from './../ducks/filters';

const FlatBuildsContainerWrapper = ({ isSubaccountDashboard, ...props }) => (
  <JobsUserContainer {...props}>
    {
      isSupportedFeature(features.DASHBOARD_TAB_AUTOMATED_BUILDS) ? (
        <FlatBuildsContainer
          breadcrumbs={[{ name: 'Automated' }, { name: 'Builds' }]}
          filterType={filterConstants.FILTER_AUTOMATED_BUILDS}
          isSubaccountDashboard={isSubaccountDashboard}
          pageTitle="Automated | Builds"
        />
      ) : (
        <FlatBuildsContainer
          breadcrumbs={[{ name: 'Headless' }, { name: 'Builds' }]}
          filterType={filterConstants.FILTER_HEADLESS_BUILDS}
          isSubaccountDashboard={isSubaccountDashboard}
          pageTitle="Headless | Builds"
        />
      )
    }
  </JobsUserContainer>
);

FlatBuildsContainerWrapper.defaultProps = {
  isSubaccountDashboard: false,
};
FlatBuildsContainerWrapper.propTypes = {
  isSubaccountDashboard: PropTypes.bool,
};

export default FlatBuildsContainerWrapper;
